(function () {
  const STORAGE_KEY = 'allure-night-mode';

  function isDark() {
    return document.documentElement.getAttribute('data-theme') === 'dark';
  }

  function setMetaTheme(hex) {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    meta.setAttribute('content', hex);
  }

  function syncChrome() {
    setMetaTheme(isDark() ? '#121212' : '');
  }

  function syncToggleUi() {
    const dark = isDark();
    document.querySelectorAll('[data-night-mode-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      const labelDark = btn.getAttribute('data-label-dark');
      const labelLight = btn.getAttribute('data-label-light');
      if (labelDark && labelLight) {
        btn.setAttribute('aria-label', dark ? labelLight : labelDark);
      }
    });
  }

  function apply(theme, persist) {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
    if (persist) {
      try {
        localStorage.setItem(STORAGE_KEY, theme);
      } catch (_) {}
    }
    syncChrome();
    syncToggleUi();
  }

  function toggle() {
    apply(isDark() ? 'light' : 'dark', true);
  }

  window.AllureNightMode = { apply, toggle, syncToggleUi };

  document.querySelectorAll('[data-night-mode-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => toggle());
  });
  syncChrome();
  syncToggleUi();
})();
